import { Avatar, AvatarInitials, Flex, FontFamilies, TextColors, Typography } from "@abel-technologies-as/components";
import { ConfirmaPayoutData } from "./ConfirmaPayoutTable.types";
import { getInitials } from "@/shared/utils";
import i18n from "i18next";

const t = (key: string) => i18n.t(key, { ns: "dhc" });

export const renderColumns = () => {
	return [
		{
			field: "name",
			headerName: t("name"),
			sortable: false,
			width: 300,
			renderCell: (row: ConfirmaPayoutData) => {
				return (
					<Flex justifyContent={"flex-start"} gap={"12px"}>
						{row.imageUrl?.length ? (
							<Avatar size={24} imageUrl={row.imageUrl} />
						) : (
							<AvatarInitials initials={getInitials(row.name)} />
						)}
						<Typography
							fontFamily={FontFamilies.InterRegular}
							fontWeight={400}
							fontSize={"14px"}
							color={TextColors.Tertiary}
							lineHeight={"20px"}>
							{row.name}
						</Typography>
					</Flex>
				);
			},
		},
		{
			field: "finalPayout",
			headerName: t("final_payout"),
			sortable: false,
			width: 300,
			renderCell: (row: ConfirmaPayoutData) => {
				return (
					<Typography
						fontFamily={FontFamilies.InterRegular}
						fontWeight={400}
						fontSize={"14px"}
						color={TextColors.Tertiary}
						lineHeight={"20px"}>
						{row.finalPayout}
					</Typography>
				);
			},
		},
	];
};
